
import React, { useEffect, useState,useRef  } from "react";
import { AxiosResponse,AxiosError } from "axios";
import { Result, supplyLimit } from "../../interface/SupplyLimit";
import { ColumnDef } from "@tanstack/react-table";
import { Button } from "../../components/ui/button";
import { SupplyLimitAxiosInstance } from "../../Network/SupplyLimitAxiosInstance";
import { Option } from "../../interface/Option";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion"
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/Label";
import { Toaster } from "../../components/ui/toaster";
import { useToast } from "../../hooks/use-toast";
import DataTable2 from "shared/DataTable2";
import ListOfNewNetworkName from "../Shared/NewNetworkName"
import ListOfInsuranceplanName from "../Shared/ListOfInsuranceplanName";
import Patient from "../Shared/Patient"
import ListOfProviderName from "../Shared/ListOfProviderName"
import PolicyNames from "../Shared/PolicyNames";
import ListOfDrugCode from "../Shared/DrugCode";

const SupplyLimit: React.FC = () => {
    // Main data state
   const [items, setItems] = useState<supplyLimit>({ result: [] });

  // Form states
 const [Name, setName] = useState<string>("");
  const [DrugCode, setDrugCode] = useState<Option[]>([]); 
  const [SupplyLimit, setSupplyLimit] =  useState<number | undefined>();
  const [Dosage, setDosage] =   useState<number | undefined>();
  const [frequencyType, setFrequencyType] = useState<string>("daily");
  const timestamp = new Date().toISOString();
const [provider, setProvider] = useState<Option[]>([]);
  const [applyToOtherProviders, setApplyToOtherProviders] =useState<boolean>(false);
  const [networks, setNetworks] = useState<Option[]>([]);
  const [apply_to_other_networks, setApply_to_other_networks] =useState<boolean>(false);
  const [insuranceplan, setInsuranceplan] = useState<Option[]>([]);
  const [apply_to_other_insuranceplan, setapply_to_other_insuranceplan] =useState<boolean>(false);
  const [Payer, setPayer] = useState<string[]>([]);
  const [apply_to_other_payer, setapply_to_other_payer] =useState<boolean>(false);
  const [patients, setPatients] = useState<Option[]>([]);
  const [apply_to_other_patients, setApply_to_other_patients] =useState<boolean>(false);
  const [policy, setPolicy] = useState<Option[]>([]);
   const [apply_to_other_policy, setApply_to_other_policy] =useState<boolean>(false);
  const [userLevel, setUserLevel] = useState<string[]>([]);
  const [apply_to_other_user, setApply_to_other_user] =useState<boolean>(false);
  const [apply_to_other_vip, setApply_to_other_vip] =useState<boolean>(false);

   // UI control states
 const [editIndex, setEditIndex] = useState<null | number>(null);
 const [isDialogOpen, setIsDialogOpen] = useState(false);
 const [clearDrugCode, setClearDrugCode] = useState(false);
   const [clearNetworks, setClearNetworks] = useState(false);
   const [clearInsuranceplan, setClearInsuranceplan] = useState(false);
  const [clearProvider, setClearProvider] = useState(false);
    const [clearPatient, setClearPatient] = useState(false);
    const [clearPolicy, setClearPolicy] = useState(false);
 

   // dialog for details
     const [selectedItem, setSelectedItem] = useState<Result | null>(null);
     const dialogRef = useRef<HTMLDialogElement | null>(null);

// Get token from localStorage
  const token = localStorage.getItem("token") || "";

  // Initialize toast
  const { toast } = useToast();

const clear= () =>{
  setName("");
  setDrugCode([]);
 setSupplyLimit(undefined);
 setDosage(undefined);
 setFrequencyType("daily");
setProvider([]);
  setApplyToOtherProviders(false);
  setNetworks([]);
  setApply_to_other_networks(false);
  setInsuranceplan([]);
  setapply_to_other_insuranceplan(false);
  setPayer([]);
  setapply_to_other_payer(false);
  setPatients([]);
 setApply_to_other_patients(false);
 setApply_to_other_vip(false);
  setApply_to_other_policy(false);
   setApply_to_other_user(false);
   setPolicy([]);
 setUserLevel([]);
}
useEffect(() => {
  fetchItems();
}, []);


const handleOpenDialog = (item: Result) => {
  setSelectedItem(item);
  dialogRef.current?.showModal(); 
};

const handleCloseDialog = () => {
  dialogRef.current?.close(); 
  setSelectedItem(null);
};
  const handleEditClick = (item: Result) => {
    handleEdit(item);
    setIsDialogOpen(true); }

    const handleAddClick = () => {
      setEditIndex(null);
      clear();
      setIsDialogOpen(true); }

 

     

 const handleDrugChange = (selectedOptions: Option[]) => {
          console.log("selected:", selectedOptions);
          setDrugCode(selectedOptions);};
 const handleInsuranceplanChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setInsuranceplan(selectedOptions);
  };
  const handleNetworkChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setNetworks(selectedOptions);
  };

  const handlePoliciesChange = (selectedOptions: Option[]) => {
            setPolicy(selectedOptions);
              };
       const handlePatientChange = (selectedOptions: Option[]) => {
           setPatients(selectedOptions);
                                           };
         const handleProviderChange = (selectedOptions: Option[]) => {
              setProvider(selectedOptions);
                    };
  


// API functions
  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Result[] }> =
        await SupplyLimitAxiosInstance.get("getSupplyLimit");
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result);
    } catch (error) {
      console.error("Error fetching items:", error);
      toast({
        title: "Error",
        description: "Failed to fetch Supply Limit Groups",
        variant: "destructive",
      });
    }
  };

  const addItem = async (): Promise<void> => {
    if (!Name.trim() ) {
      toast({
        title: "Error",
        description: " Name is required and cannot be empty.",
        variant: "destructive",
      });
      return;
    }
    if (Name.trim().length < 3 ) {
      toast({
        title: "Error",
        description: " Name must be at least 3 characters long.",
        variant: "destructive",
      });}
   const ValuesDrugcode = DrugCode.map((option) => option.value);
    const ValuesNetwork = networks.map((option) => option.value);
    const ValuesInsurancePlan = insuranceplan.map((option) => option.value);
    const ValuesPolicy = policy.map((option) => option.value);
    const ValuesPatient = patients.map((option) => option.value);
    const ValuesProvider = provider.map((option) => option.value);
   try {

      const newGroupArray = 
        {
          relation_name:Name,
            drugs: ValuesDrugcode,
            supply_limit: SupplyLimit,
            dosage: Dosage,
            frequency_type: frequencyType,
            timestamp: timestamp,
            provider: ValuesProvider,
            apply_to_other_providers: applyToOtherProviders,
            networks:ValuesNetwork,
           apply_to_other_networks:  apply_to_other_networks ,
           insuranceplan:ValuesInsurancePlan,
            apply_to_other_insuranceplan:apply_to_other_insuranceplan,
           payer:Payer,
            apply_to_other_payer:apply_to_other_payer,
            patients:ValuesPatient,
            apply_to_other_patients:apply_to_other_patients,
            policy:ValuesPolicy,
            apply_to_other_policy:apply_to_other_policy,
            user_level:userLevel,
            apply_to_other_user:apply_to_other_user,
            apply_to_vip:apply_to_other_vip,
            token: token,
    }
      
    console.log(newGroupArray);
   const response = await SupplyLimitAxiosInstance.post("addSupplyLimit", newGroupArray);
  if (response.data.success) {
        fetchItems();
        clear();
        setIsDialogOpen(false);
       toast({
            title: "Success",
            description: "New Relation Supply Limit Group Added Successfully.",
          });
        } else {
          if (response.data.errors && response.data.errors.length > 0) {
            const errorDetails = response.data.errors[0]; 
            const errorMessage =
              errorDetails.error ||
              "Failed to add the group due to an unknown error.";
            toast({
              title: "Error",
              description: errorMessage,
            });
            console.log(errorMessage);
          } else {
            toast({
              title: "Error",
              description: response.data.error || "Failed to add the group.",
              variant: "destructive",
            });
            console.log(response.data.error);
          }
        }
      } catch (error: AxiosError | any) {
        toast({
          title: "Error",
          description:
            error.response?.data?.error || "An unexpected error occurred.",
            variant: "destructive",
        });
        console.error(error.response?.data?.error || error.message);
      }
  
  };


 const updateItem = async (id: string | number): Promise<void> => {
  if (!Name.trim() ) {
    toast({
      title: "Error",
      description: " Name is required and cannot be empty.",
      variant: "destructive",
    });
    return;
  }
  if (Name.trim().length < 3 ) {
    toast({
      title: "Error",
      description: " Name must be at least 3 characters long.",
      variant: "destructive",
    });
  return;
  }
    const ValuesPolicy = policy.map((option) => option.value);
    const ValuesPatient = patients.map((option) => option.value);
    const ValuesProvider = provider.map((option) => option.value);
    const ValuesDrugcode = DrugCode.map((option) => option.value);
    const ValuesNetwork = networks.map((option) => option.value);
    const ValuesInsurancePlan = insuranceplan.map((option) => option.value); 
    
    const updatedItem = {
          relation_name:Name,
          supply_limit: SupplyLimit,
           dosage: Dosage,
           drugs: ValuesDrugcode,
           frequency_type: frequencyType,
           timestamp: timestamp,
           provider: ValuesProvider,
           apply_to_other_providers: applyToOtherProviders,
            networks:ValuesNetwork,
           apply_to_other_networks:  apply_to_other_networks ,
           insuranceplan:ValuesInsurancePlan,
            apply_to_other_insuranceplan:apply_to_other_insuranceplan,
           payer:Payer,
            apply_to_other_payer:apply_to_other_payer,
            patients:ValuesPatient,
            apply_to_other_patients:apply_to_other_patients,
            policy:ValuesPolicy,
            apply_to_other_policy:apply_to_other_policy,
            user_level:userLevel,
            apply_to_other_user:apply_to_other_user,
            apply_to_vip:apply_to_other_vip,
  id: id,
  token: token,
    };

    console.log("updatedItem",updatedItem);

    try {
        const response = await SupplyLimitAxiosInstance.put(
            `updateSupplyLimit`,
            updatedItem
        );

        if (response.data.success) {
            fetchItems();
            clear();
            setIsDialogOpen(false);
            toast({
                title: "Success",
                description: "Relation Supply Limit Group updated successfully.",
            });
        }
    } catch (error: AxiosError | any) {
        console.error("Error during the request: ", error);
        toast({
            title: "Error",
            description:
                error.response?.data?.error || "An unexpected error occurred.",
            variant: "destructive",
        });
    }
};

  const deleteItem = async (id: string | number): Promise<void> => {
    try {
      const response: AxiosResponse = await SupplyLimitAxiosInstance.delete(
        `deleteSupplyLimit/${id}`, {
      
           data: { token: token }, 
         }
      );
      if (response.data.success) {
        console.log("Supply Limit Relation  Deleted Successfully:", response.data);
        fetchItems();
        toast({
          title: "Success",
          description: "Supply Limit Relation Deleted Successfully.",
        });
      } else {
        toast({
          title: "Error",
          description: response.data.error||"Failed to delete Relation Supply Limit.",
          variant: "destructive",
        });
        console.error("Error deleting Relation Supply Limit:",);
      }
    } catch (error) {
      toast({
        title: "Error",
        description:"Failed to delete Relation Supply Limit.",
        variant: "destructive",
      });
    }
  };


const handleEdit = (item: Result) => {
   const mapToOptions = (arr: (string | number)[]): Option[] =>
        arr.map((value) => ({
          value: value, // Actual value
          label: value.toString(), // The text that will appear in the Select
        }));
    
setName(item.relation_name);
    setDrugCode(mapToOptions(item.drugs));
    setSupplyLimit(item.supply_limit || 0);
    setFrequencyType(item.frequency_type || "daily");
    setDosage(item.dosage || 0);
     
// Convert or process fields Networks
   const networksData = Array.isArray(item.networks)
   ? item.networks.map((obj) =>
       typeof obj === "string"
         ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
         : obj // If the element is an object, use it as is.
     )
   : [];

 setNetworks(
   networksData.map((obj) => ({
     value: obj.id,
     label: obj.name,
   }))
 );

 //Convert or process insuranceplan fields
 const insuranceplanData = Array.isArray(item.insuranceplan)
   ? item.insuranceplan.map((obj) =>
       typeof obj === "string"
         ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
         : obj // If the element is an object, use it as is.
     )
   : [];

 setInsuranceplan(
   insuranceplanData.map((obj) => ({
     value: obj.id,
     label: obj.name,
   }))
 );
    // Convert or process fields Providers 
   const ProvidersData = Array.isArray(item.provider)
   ? item.provider.map((obj) =>
       typeof obj === "string"
         ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
         : obj // If the element is an object, use it as is.
     )
   : [];

 setProvider(
   ProvidersData.map((obj) => ({
     value: obj.id,
     label: obj.name,
   }))
 );
 // Convert or process fields Patients
   const PatientsData = Array.isArray(item.patients)
   ? item.patients.map((obj) =>
       typeof obj === "string"
         ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
         : obj // If the element is an object, use it as is.
     )
   : [];

 setPatients(
   PatientsData.map((obj) => ({
     value: obj.id,
     label: obj.name,
   }))
 );
    //Convert or process Policy fields
    const PolicyData = Array.isArray(item.policy)
    ? item.policy.map((obj) =>
        typeof obj === "string"
          ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
          : obj // If the element is an object, use it as is.
      )
    : [];

    setPolicy(
    PolicyData.map((obj) => ({
      value: obj.id,
      label: obj.name,
    }))
  );

 setApply_to_other_policy(item.apply_to_other_policy);
  setApply_to_other_user(item.apply_to_other_user);
  setApply_to_other_vip(item.apply_to_vip);
  setUserLevel(item.user_level);
    setApplyToOtherProviders(item.apply_to_other_providers);
    setApply_to_other_networks(item.apply_to_other_networks);
    setapply_to_other_insuranceplan(item.apply_to_other_insuranceplan);
    setPayer(item.payer);
    setapply_to_other_payer(item.apply_to_other_payer);
    setApply_to_other_patients(item.apply_to_other_patients);
    setEditIndex(item.id);
};

  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const item = row.original;
        return (
          <button onClick={() => handleOpenDialog(item)} className="id-button">
            {item.id}
          </button>
        );
      }
    },
     {
          accessorKey: "relation_name",
          header: ({ column }) => (
            <Button
              variant="ghost"
              onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
            >
              Name
              {column.getIsSorted() === "asc"
                ? " ↑"
                : column.getIsSorted() === "desc"
                ? " ↓"
                : ""}
            </Button>
          ),
        },
      {
            accessorKey: "drugs",
            header: ({ column }) => (
              <Button
                variant="ghost"
                onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
              >
               Drug Code
                {column.getIsSorted() === "asc"
                  ? " ↑"
                  : column.getIsSorted() === "desc"
                  ? " ↓"
                  : ""}
              </Button>
            ), 
             cell: ({ row }) => {
              const  Activity= row.getValue("drugs") as string[];
              return Array.isArray( Activity) ?   Activity.join(", ") :   Activity;
            },
            
          },
    {
      accessorKey: "supply_limit",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
        Supply Limit
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    }, 

  
   ];

 
  return (
    <div className=" h5-container mx-auto p-8">
    <h5 className="mb-6 flex items-center gap-2" style={{fontWeight:"bolder" ,fontSize:"22px",  marginTop:"15px"}}>
    <span className="icon-container">
                    <i className="fa-solid fa-list"></i>
                </span>
                Supply Limit </h5>
     
      {/* model */}
      {/* tabIndex="-1" */}
      {Boolean(selectedItem) && (
       <dialog ref={dialogRef} className="custom-dialog" open>
         {selectedItem && (
           <div className="dialog-content">
             {/* top-dialog-close-icon */}
             <button className="dialog-close-icon" onClick={handleCloseDialog}>
               ×
             </button>
             {/* dialog-title */}
             <h2 className="dialog-title">
               <span>Details for ID:</span> {selectedItem.id}
             </h2>
        {/* Content */}
 <div className="dialog-grid">
          <div className="dialog-row two-col-row">
            <div className="dialog-item">
              <strong>Relation Name:</strong> <span>{selectedItem.relation_name}</span>
            </div>
            
          </div>   
         
          <div className="dialog-row three-col-row">
          <div className="dialog-item">
            <strong>Drug Code:</strong>
            <p>{selectedItem.drugs.join(", ")}</p>
          </div>
           <div className="dialog-item">
              <strong>Frequency Type:</strong> <span>{selectedItem.frequency_type}</span>
            </div>
                       <div className="dialog-item">
       <strong>Created At:</strong>
       <p>{new Date(selectedItem.created_at).toISOString().split('T')[0]}</p>
     </div>
        </div>
             <div className="dialog-row three-col-row">
             <div className="dialog-item">
       <strong>Supply Limit</strong>
       <p>{selectedItem.supply_limit}</p>
       
       </div>
     <div className="dialog-item">
       <strong>Dosge:</strong>
       <p>{selectedItem.dosage}</p>
     </div>
         <div className="dialog-item">
              <strong>total:</strong> <span>{selectedItem.total}</span>
            </div>
                </div>

             <div className="dialog-row two-col-row">
            <div className="dialog-item">
              <strong>Networks:</strong> <span>{selectedItem.networks.map(n => n.name).join(", ")}</span>
              <strong className="ml-6"> Apply TO Other Networks:</strong> <span>{String(selectedItem.apply_to_other_networks)}</span>
            </div>
            <div className="dialog-item">
              <strong>Insurance Plan:</strong> <span>{selectedItem.insuranceplan.map(n => n.name).join(", ")}</span>
              <strong className="ml-6"> Apply To Other Insurance Plan :</strong> <span>{String(selectedItem.apply_to_other_insuranceplan)}</span>
            </div>
           </div>
                                 <div className="dialog-row two-col-row">
          <div className="dialog-item">
              <strong>Payers:</strong> <span>{selectedItem.payer.join(", ")}</span>
              <strong className="ml-6"> Apply To Other Payers:</strong> <span>{String(selectedItem.apply_to_other_payer)}</span>
            </div>
            <div className="dialog-item">
              <strong>Provider:</strong> <span>{selectedItem.provider.map(n => n.name).join(", ")}</span>
              <strong className="ml-6"> Apply To Other Provider:</strong> <span>{String(selectedItem.apply_to_other_providers)}</span>
            </div>
           </div>
          <div className="dialog-row two-col-row">
            <div className="dialog-item">
              <strong>Policy:</strong> <span>{selectedItem.policy.map(n => n.name).join(", ")}</span>
              <strong className="ml-6"> Apply To Other Policy:</strong> <span>{String(selectedItem.apply_to_other_policy)}</span>
            </div>
            <div className="dialog-item">
              <strong>Patients:</strong> <span>{selectedItem.patients.map(n => n.name).join(", ")}</span>
<strong className="ml-6"> Apply To Other Patients:</strong> <span>{String(selectedItem.apply_to_other_patients)}</span>
</div>
          </div>
          <div className="dialog-row two-col-row">
          <div className="dialog-item">
              <strong>User Level:</strong> <span>{selectedItem.user_level.join(", ")}</span>
              <strong className="ml-6"> Apply To Other User Level:</strong> <span>{String(selectedItem.apply_to_other_user)}</span>
            </div>
            <div className="dialog-item">
              <strong>Apply To VIP:</strong> <span>{String(selectedItem.apply_to_vip)}</span>
            </div>
          </div>
        </div>
        <button className="dialog-close-btn" onClick={handleCloseDialog}>Close</button>
      </div>
    )}
  </dialog>
)}

           <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
       <DialogContent>
         <DialogHeader>
           <DialogTitle>
             {editIndex === null ? "Add Supply Limit" : "Edit Supply Limit"}
           </DialogTitle>
           </DialogHeader>

<div className="grid grid-cols-2 gap-4 mt-4">
  {/* First Column */}
  <div>
    <div className="mb-4">
      <Label htmlFor="name">Name</Label>
      <Input
        id="name"
        value={Name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Name is required"
      />
    </div>
    <div className="mb-4">
      <Label htmlFor="drug_code">Drug Code:</Label>
      <ListOfDrugCode
        onChange={handleDrugChange}
        defaultValue={DrugCode}
        clear={clearDrugCode}
      />
    </div>
    
    <div className="mb-4">
      <Label htmlFor="SupplyLimit">Supply Limit</Label>
      <Input
      type="number"
        id="SupplyLimit"
        value={SupplyLimit}
           onChange={(e) => {
    const value = e.target.value;
    setSupplyLimit(value === "" ? undefined : Number(value));
  }}
        placeholder="Enter Supply Limit"
      />
    </div>
   
    <div className="mb-4">
      <Label>Providers:</Label>
      <ListOfProviderName onChange={handleProviderChange} defaultValue={provider} clear={clearProvider} />
    </div>
    <div className="mb-4">
      <Label>Networks:</Label>
      <ListOfNewNetworkName
        onChange={handleNetworkChange}
        defaultValue={networks}
        clear={clearNetworks}
      />
    </div>
    <div className="mb-4">
      <Label>Insurance Plan:</Label>
      <ListOfInsuranceplanName
        onChange={handleInsuranceplanChange}
        defaultValue={insuranceplan}
        clear={clearInsuranceplan}
      />
    </div>
    <div className="mb-4">
      <Label>Payer:</Label>
      <Input
        value={Payer.join(",")}
        onChange={(e) => setPayer([e.target.value])}
        placeholder="Enter Payer"
      />
    </div>
    <div className="mb-4">
      <Label>Patients:</Label>
      <Patient onChange={handlePatientChange} defaultValue={patients} clear={clearPatient} />
    </div>
    <div className="mb-4">
      <Label>Policy:</Label>
<PolicyNames onChange={handlePoliciesChange}  defaultValue={policy}  clear={clearPolicy} />
    </div>
    <div className="mb-4">
      <Label>User Level:</Label>
      <Input
        value={userLevel.join(",")}
        onChange={(e) => setUserLevel([e.target.value])}
        placeholder="Enter User Level"
      />
    </div>
  </div>

  {/* Second Column 2 */}
  <div>
      <div className="m-1 min-h-[80px] min-w-[100px]">
      </div>
     <div className="mb-4">
      <Label htmlFor="FrequencyType">Frequency Type:</Label>
      <select
        className="form-select"
        value={frequencyType}
        onChange={(e) => setFrequencyType(e.target.value)}
      >
        <option value="">Select an Type</option>
        <option value="daily">Daily</option>
         <option value="weekly">Weekly</option>
         <option value="monthly">Monthly</option>
          <option value="quarterly">quarterly</option>
          <option value="yearly">yearly</option>

      </select>
    </div>
     <div className="mb-2">
      <Label htmlFor="dosage">Dosage</Label>
      <Input
      type="number"
        id="Dosage"
        value={Dosage}
        
        onChange={(e) => {
    const value = e.target.value;
    setDosage(value === "" ? undefined : Number(value));
  }}
        placeholder="Enter Dosage"
      />
    </div>
  
    <div className="mb-3 w-80">
      <Accordion type="single" collapsible>
        <AccordionItem value="item-1">
          <AccordionTrigger>Apply To Other Providers?</AccordionTrigger>
          <AccordionContent>
            <div>
              <label>
                <input
                  type="radio"
                  name="Providers"
                  value="true"
                  checked={applyToOtherProviders === true}
                  onChange={(e) => setApplyToOtherProviders(e.target.value === "true")}
                />{" "}
                True
              </label>
              <label className="ml-4">
                <input
                  type="radio"
                  name="Providers"
                  value="false"
                  checked={applyToOtherProviders === false}
                  onChange={(e) => setApplyToOtherProviders(e.target.value === "true")}
                />{" "}
                False
              </label>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
    <div className="mb-3 w-80">
      <Accordion type="single" collapsible>
        <AccordionItem value="item-1">
          <AccordionTrigger>Apply To Other Networks:</AccordionTrigger>
          <AccordionContent>
            <div>
              <label>
                <input
                  type="radio"
                  name="Networks"
                  value="true"
                  checked={apply_to_other_networks === true}
                  onChange={(e) => setApply_to_other_networks(e.target.value === "true")}
                />{" "}
                True
              </label>
              <label className="ml-4">
                <input
                  type="radio"
                  name="Networks"
                  value="false"
                  checked={apply_to_other_networks === false}
                  onChange={(e) => setApply_to_other_networks(e.target.value === "true")}
                />{" "}
                False
              </label>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
    <div className="mb-3 w-80">
      <Accordion type="single" collapsible>
        <AccordionItem value="item-1">
          <AccordionTrigger>Apply To Other Insurance Plan:</AccordionTrigger>
          <AccordionContent>
            <div>
              <label>
                <input
                  type="radio"
                  name="Insurance"
                  value="true"
                  checked={apply_to_other_insuranceplan === true}
                  onChange={(e) => setapply_to_other_insuranceplan(e.target.value === "true")}
                />{" "}
                True
              </label>
              <label className="ml-4">
                <input
                  type="radio"
                  name="Insurance"
                  value="false"
                  checked={apply_to_other_insuranceplan === false}
                  onChange={(e) => setapply_to_other_insuranceplan(e.target.value === "true")}
                />{" "}
                False
              </label>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
    <div className="mb-3 w-80">
      <Accordion type="single" collapsible>
        <AccordionItem value="item-1">
          <AccordionTrigger>Apply To Other Payer:</AccordionTrigger>
          <AccordionContent>
            <div>
              <label>
                <input
                  type="radio"
                  name="Payer"
                  value="true"
                  checked={apply_to_other_payer === true}
                  onChange={(e) => setapply_to_other_payer(e.target.value === "true")}
                />{" "}
                True
              </label>
              <label className="ml-4">
                <input
                  type="radio"
                  name="Payer"
                  value="false"
                  checked={apply_to_other_payer === false}
                  onChange={(e) => setapply_to_other_payer(e.target.value === "true")}
                />{" "}
                False
              </label>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
    <div className="mb-3 w-80">
      <Accordion type="single" collapsible>
        <AccordionItem value="item-1">
          <AccordionTrigger>Apply To Other Patients:</AccordionTrigger>
          <AccordionContent>
            <div>
              <label>
                <input
                  type="radio"
                  name="Patients"
                  value="true"
                  checked={apply_to_other_patients === true}
                  onChange={(e) => setApply_to_other_patients(e.target.value === "true")}
                />{" "}
                True
              </label>
              <label className="ml-4">
                <input
                  type="radio"
                  name="Patients"
                  value="false"
                  checked={apply_to_other_patients === false}
                  onChange={(e) => setApply_to_other_patients(e.target.value === "true")}
                />{" "}
                False
              </label>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  <div className="mb-3 w-80">
                  <Accordion type="single" collapsible>
                   <AccordionItem value="item-1">
       <AccordionTrigger>Apply To Other Policy:</AccordionTrigger>
                  <AccordionContent>
                      <div>
                         <label>
                        <input
                        type="radio"
                         name="Policy"
                        value="true"
                       checked={apply_to_other_policy === true}
                        onChange={(e) => setApply_to_other_policy(e.target.value === "true")}
                               />{" "}
                             True
                           </label>
                             <label className="ml-4">
                               <input
                               type="radio"
                            name="Policy"
                            value="false"
                         checked={apply_to_other_policy === false}
                      onChange={(e) => setApply_to_other_policy(e.target.value === "true")}
                                   />{" "}
                                 False
                                 </label>
                 </div>
                     </AccordionContent>
                        </AccordionItem>
                     </Accordion>
                                                </div>
    <div className="mb-3 w-80">
      <Accordion type="single" collapsible>
        <AccordionItem value="item-1">
          <AccordionTrigger>Apply To Other User:</AccordionTrigger>
          <AccordionContent>
            <div>
              <label>
                <input
                  type="radio"
                  name="user"
                  value="true"
                  checked={apply_to_other_user === true}
                  onChange={(e) => setApply_to_other_user(e.target.value === "true")}
                />{" "}
                True
              </label>
              <label className="ml-4">
                <input
                  type="radio"
                  name="user"
                  value="false"
                  checked={apply_to_other_user === false}
                  onChange={(e) => setApply_to_other_user(e.target.value === "true")}
                />{" "}
                False
              </label>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
    <div className="mb-3 w-80">
      <Accordion type="single" collapsible>
        <AccordionItem value="item-1">
          <AccordionTrigger>Apply To Vip:</AccordionTrigger>
          <AccordionContent>
            <div>
              <label>
                <input
                  type="radio"
                  name="Vip"
                  value="true"
                  checked={apply_to_other_vip === true}
                  onChange={(e) => setApply_to_other_vip(e.target.value === "true")}
                />{" "}
                True
              </label>
              <label className="ml-4">
                <input
                  type="radio"
                  name="Vip"
                  value="false"
                  checked={apply_to_other_vip === false}
                  onChange={(e) => setApply_to_other_vip(e.target.value === "true")}
                />{" "}
                False
              </label>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  </div>
</div>

    <DialogFooter className="gap-2 m-4">
      <Button
        onClick={() => {
          if (editIndex === null) {
            addItem();
          } else {
            updateItem(editIndex);
          }
        }}
        className="bg-blue-600 hover:bg-blue-700"
      >
        {editIndex === null ? "Add relation " : "Update Relation "}
      </Button>
      <Button
        variant="outline"
        onClick={() => {
          setEditIndex(null);
          clear();
          setIsDialogOpen(false);
        }}
      >
        Cancel
      </Button>
    </DialogFooter>
  </DialogContent>
</Dialog>


 {/* table */}

      <DataTable2
        columns={columns}
        data={items.result}
        searchColumns={["relation_name"]}
        addButtonLabel="Add New Relation "
        showAddButton={true}
        onEdit={handleEdit}
        onDelete={deleteItem}
        onAdd={handleAddClick}
        onEditClick={handleEditClick}
 
/>

    <Toaster />
    </div>
  );
};

export default SupplyLimit  ;


